export const MAX_TX_SIZE: number = 1232;
export const MAX_ACCOUNT_LOCKS = 64;
export const BUNDLE_TX_SIZE: number = 81;
export const PRIORITY_TX_SIZE: number = 44;
